/**
 * Formats toggle name from SCREAMING_SNAKE_CASE to Title Case
 * Example: TEST_FEATURE_TOGGLE -> Test Feature Toggle
 */
export const formatToggleName = (name: string): string => {
  return name
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function formatTimestamp(iso: string) {
  const d = new Date(iso)
  return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
}

export function formatDate(iso: string) {
  const d = new Date(iso)
  const now = new Date()
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
  if (d.toDateString() === now.toDateString()) return `Today, ${time}`
  return `${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${time}`
}

export function formatDuration(seconds?: number) {
  if (seconds == null) return '—'
  if (seconds < 60) return `${seconds}s`
  const min = Math.floor(seconds / 60)
  const sec = seconds % 60
  return sec > 0 ? `${min}m ${sec}s` : `${min}m`
}

export function formatDurationFromDates(createdAt: string, completedAt?: string) {
  if (!completedAt) return null
  const ms = new Date(completedAt).getTime() - new Date(createdAt).getTime()
  const seconds = Math.round(ms / 1000)
  return formatDuration(seconds)
}
